import {
    CHANGE_TIMEZONE_OPEN_MODAL,
    CHANGE_TIMEZONE_CLOSE_MODAL,
    CHANGE_TIMEZONE_UPDATE_REQUEST,
    CHANGE_TIMEZONE_UPDATE_RESULT,
    CHANGE_TIMEZONE_SET_DEVICES,
    CLEAR_REDUX,
} from 'Redux/actionTypes';

const INIT_STATE = {
    loading: false,
    openModal: false,
    result: null,
    devices: []
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case CHANGE_TIMEZONE_SET_DEVICES:
            return { ...state, devices: action.payload }

        case CHANGE_TIMEZONE_OPEN_MODAL:
            return { ...state, openModal: true, devices: action.payload }

        case CHANGE_TIMEZONE_CLOSE_MODAL:
            return { ...state, openModal: false }

        case CHANGE_TIMEZONE_UPDATE_REQUEST:
            return { ...state, loading: true }

        case CHANGE_TIMEZONE_UPDATE_RESULT:
            return { ...state, loading: false, result: action.payload }

        case CLEAR_REDUX:
            return ["", "CHANGE_TIMEZONE"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};